import { SlashCommand } from './index';

export const justRecordCommands: SlashCommand[] = [
    {
        id: 'transcribe',
        name: 'Transcribe Media',
        trigger: '/transcribe',
        description: 'Transcribes attached audio or video files into text.',
        category: 'JustRecord.me',
        icon: 'fa-microphone',
        integration: 'JustRecord.me',
        mode: 'tool',
        tool: 'justrecord',
        prefix: 'transcribe this: '
    },
    {
        id: 'yttranscribe',
        name: 'Transcribe YouTube',
        trigger: '/yttranscribe',
        description: 'Transcribes a YouTube video into text.',
        category: 'JustRecord.me',
        icon: 'fa-youtube',
        integration: 'JustRecord.me',
        mode: 'tool',
        tool: 'exportyt',
        prefix: 'transcribe this youtube video: '
    }
];
